//中文
export default {
    今日涨跌:"今日涨跌",
    商品:"商品",
    交割: "交割",
    关于我们: "关于我们",
    账变记录: "账变记录",
    股票: "股票",
    加密货币: "加密货币",
    加载中: "加载中...",
    已经全部加载完毕: "已经全部加载完毕",
    暂无记录: "暂无记录",
    高级认证: "高级认证",
    姓名: "姓名",
    请输入姓名: "请输入姓名",
    护照编号: "护照编号",
    请输入护照编号: "请输入护照编号",
    护照照片: "护照照片",
    申请认证: "申请认证",
    提示: "提示",
    确定: "确定",
    提交失败: "提交失败",
    上传失败: "上传失败",
    身份认证: "身份认证",
    身份证号: "身份证号",
    请输入身份证号: "请输入身份证号",
    身份证照片: "身份证照片",
    申请认证: "申请认证",
    修改资金密码: "修改资金密码",
    旧密码: "旧密码",
    请输入旧密码: "请输入旧密码",
    新密码: "新密码",
    请输入6位数字: "请输入6位数字",
    确认新密码: "确认新密码",
    请再次输入新密码: "请再次输入新密码",
    提交: "提交",
    请输入新密码: "请输入新密码",
    请输入6位数新密码: "请输入6位数新密码",
    请确认两次密码输入一致: "请确认两次密码输入一致",
    修改登录密码: "修改登录密码",
    密码长度: "密码（6-12个字符）",
    密码长度提示: "请输入6-12个字符，包括数字或字母",
    客服: "客服",
    永续: "永续",
    交割: "交割",
    永续合约: "永续合约",
    交割合约: "交割合约",
    全仓: "全仓",
    开多: "开多",
    开空: "开空",
    价格: "价格",
    开仓金额: "开仓金额",
    可用金额: "可用金额",
    合约金额: "合约金额",
    保证金: "保证金",
    手续费: "手续费",
    看涨: "看涨",
    看跌: "看跌",
    交割时间: "交割时间",
    数量: "数量",
    持有仓位: "持有仓位",
    当前委托: "当前委托",
    历史订单: "历史订单",
    暂无数据: "暂无数据",
    购买价: "购买价",
    现价: "现价",
    市价: "市价",
    限价: "限价",
    金额: "金额",
    盈亏: "盈亏",
    操作: "操作",
    平仓: "平仓",
    撤单: "撤单",
    方向: "方向",
    剩余时间: "剩余时间",
    交割时间: "交割时间",
    详情: "详情",
    名称: "名称",
    最新价格: "最新价格",
    h24涨跌: "24H涨跌",
    h24涨跌幅: "24h涨跌幅",
    请输入开仓金额: "请输入开仓金额",
    请输入开仓价格: "请输入开仓价格",
    确定执行撤单操作: "确定执行撤单操作？",
    确定执行平仓操作: "确定执行平仓操作？",
    交割合约历史: "交割合约历史",
    历史仓位: "历史仓位",
    到期时间: "到期时间",
    闪兑: "闪兑",
    从: "从",
    最大: "最大",
    可用数量: "可用数量",
    至: "至",
    复制成功: "复制成功",
    基金理财: "基金理财",
    托管金额: "托管金额",
    总收益: "总收益",
    当日收益: "当日收益",
    托管订单: "托管订单",
    规则: "规则",
    日收益: "日收益",
    限额: "限额",
    周期: "周期",
    天: "天",
    立即买入: "立即买入",
    购买: "购买",
    购买日: "购买日",
    起息日: "起息日",
    派息时间: "派息时间",
    每日: "每日",
    计息结束日: "计息结束日",
    提前赎回: "提前赎回",
    预计收益: "预计收益",
    今日日收益: "今日(日收益)",
    最少可投: "最少可投",
    最大可投: "最大可投",
    请输入买入金额: "请输入买入金额",
    可用金额: "可用金额",
    请输入买入金额: "请输入买入金额",
    质押金额: "质押金额",
    累计收益: "累计收益",
    开始时间: "开始时间",
    结束时间: "结束时间",
    理财规则: "理财规则",
    理财规则1: "理财是通过将USD托管给平台，由平台的专业团队进行理财套利，参与者在资金托管期间可获得平台的理财收入分成。",
    收益计算: "收益计算",
    理财规则2: "会员在平台存入了10000U，选择了周期为5天 ，日收益为0.3%~0.5%的理财产品，则每天收益如下：",
    最低: "最低",
    最高: "最高",
    理财规则3: "既：5天后可以获得",
    理财规则4: "的收益，收益每日下发，下发的收益可随时存取，存入本金，到期满后，自动返还至您的账户。",
    关于违约金: "关于违约金",
    理财规则5: "若您希望转出未到期的本金，则会产生违约金，",
    理财规则6: "违约金=结算比例x剩余天数x投资数量。",
    理财规则7: "举例：该产品的违约金结算比例为",
      全球领先的期货和数字资产平台: "全球领先的期货和数字资产平台",
    剩余: "剩余",
    天到期投资: "天到期，投资数量为",
    则: "则",
    违约金: "违约金",
    实际退还本金为: "实际退还本金为",
    现货账户: "现货账户",
    总资产: "总资产",
    充币: "充币",
    提币: "提币",
    闪兑: "闪兑",
    投资组合: "投资组合",
    冻结数量: "冻结数量",
    帮助中心: "帮助中心",
    自选: "自选",
    行情: "行情",
    资金: "资金",
    资讯: "资讯",
    我的: "我的",
    交易对: "交易对",
    最新价: "最新价",
    成交量: "成交量",
    标记价格: "标记价格",
    h24最高价: "24h最高价",
    h24最低价: "24h最低价",
    h24成交量: "24h成交量",
    h24交易额: "24h交易额",
    分时: "分时",
    分1: "1分",
    分5: "5分",
    分15: "15分",
    分30: "30分",
    小时1: "1小时",
    天1: "1天",
    周1: "1周",
    月1: "1月",
    委托订单: "委托订单",
    最新交易: "最新交易",
    买入: "买入",
    卖出: "卖出",
    时间: "时间",
    方向: "方向",
    取消自选成功: "取消自选成功",
    添加成功: "添加成功",
    登录: "登录",
    账户: "账户",
    邮箱: "邮箱",
    手机号: "手机号",
    请输入账户: "请输入账户",
    请输入邮箱: "请输入邮箱",
    请输入手机号: "请输入手机号",
    密码: "密码",
    请输入密码: "请输入密码",
    忘记密码: "忘记密码?",
    还没有账号: "还没有账号",
    去注册: "去注册",
    请输入登录账号: "请输入登录账号",
    请输入登录密码: "请输入登录密码",
    登录失败: "登录失败",
    历史记录: "历史记录",
    充值: "充值",
    提现: "提现",
    未审核: "未审核",
    成功: "成功",
    失败: "失败",
    快捷入口: "快捷入口",
    资金密码: "资金密码",
    登录密码: "登录密码",
    账变记录: "账变记录",
    邀请推广: "邀请推广",
    通用: "通用",
    语言: "语言",
    在线客服: "在线客服",
    身份认证: "身份认证",
    高级认证: "高级认证",
    更多: "更多",
    帮助中心: "帮助中心",
    关于我们: "关于我们",
    退出: "退出",
    已提交身份认证: "您已提交过身份信息，正在审核中",
    您已完成身份认证: "您已完成身份认证",
    您已完成高级认证: "您已完成高级认证",
    确定退出登录: "确定退出登录?",
    资讯: "资讯",
    公告: "公告",
    状态: "状态",
    已成交: "已成交",
    委托金额: "委托金额",
    剩余金额: "剩余金额",
    订单类型: "订单类型",
    市价委托: "市价委托",
    限价委托: "限价委托",
    订单号: "订单号",
    委托时间: "委托时间",
    U本位合约历史: "U本位合约历史",
    成交数量: "成交数量",
    实现盈亏: "实现盈亏",
    推广记录: "推广记录",
    我的总推广: "我的总推广",
    总充值: "总充值",
    一代人数: "一代人数",
    二代人数: "二代人数",
    三代人数: "三代人数",
    立即推广: "立即推广",
    我的推广: "我的推广",
    用户名: "用户名",
    行情: "行情",
    加密货币: "加密货币",
    外汇: "外汇",
    股票: "股票",
    现货交易: "现货交易",
    期货:"期货交易",
    热门: "热门",
    涨幅榜: "涨幅榜",
    跌幅榜: "跌幅榜",
    快速充币: "快速充币",
    保存二维码: "保存二维码",
    复制地址: "复制地址",
    转出地址: "转出地址(选填)",
    请输入转出地址: "请输入转出地址",
    粘贴: "粘贴",
    充币数量: "充币数量",
    请输入充币数量: "请输入充币数量",
    区块链网络: "区块链网络",
    付款凭证: "付款凭证（上传支付详情截图）",
    请输入充值数量: "请输入充值数量",
    充值通道: "充值通道",
    请选择充值币种: "请选择充值币种",
    官方充值通道: "官方充值通道",
    设置密码: "设置密码",
    确认密码: "确认密码",
    验证码: "验证码",
    请输入验证码: "请输入验证码",
    获取验证码: "获取验证码",
    重新发送: "重新发送",
    邀请码: "邀请码",
    请输入邀请码: "请输入邀请码",
    我已阅读并同意: "我已阅读并同意",
    服务条款: "服务条款",
    注册: "注册",
    已有账号: "已有账号",
    去登录: "去登录",
    请再次输入密码: "请再次输入密码",
    请同意服务条款: "请同意服务条款",
    注册失败: "注册失败",
    欢迎来到: "欢迎来到",
    全球最大的区块链资产平台: "全球最大的区块链资产平台",
    分享二维码: "分享二维码",
    链接分享: "链接分享",
    复制: "复制",
    您的邀请码: "您的邀请码",
    到数字币地址: "到数字币地址",
    选择币种: "选择币种",
    区块链网络: "区块链网络",
    提币说明: "提币说明",
    提现费用: "提现费用",
    可到账数量: "可到账数量",
    可用: "可用",
    请输入支付密码: "请输入支付密码",
    请输入提币数量: "请输入提币数量",
    全部: "全部",
    支付密码: "支付密码",
    地址: "地址",
    委托价: "委托价",
    成交时间: "成交时间",
    成交金额: "成交金额",
    委托中: "委托中",
    持仓中: "持仓中",
    平仓中: "平仓中",
    已平仓: "已平仓",
    开仓倍数: "开仓倍数",
    委托价格: "委托价格",
    收盘价: "收盘价",
    收益率: "收益率",
    平仓时间: "平仓时间",
    请输入转换数量: "请输入转换数量",
    请上传付款凭证: "请上传付款凭证",
    开盘价: "开盘价",
    开市中: "开市中",
    已休市: "已休市",
    美股: "美股",
    平仓价: "平仓价",
    到期结算完成: "到期结算完成",
    印度股票: "印度股票",
    马来股票: "马来股票",
    结算中: "结算中",
    越南股票: "越南股票",
    设置资金密码: "设置资金密码",
    请输入资金密码: "请输入资金密码",
    取消:"取消",
    确定:"确定",
    止损价:"止损价",
    请输入止损价格:"请输入止损价格",
    请输入止盈价格:"请输入止盈价格",
    止盈价:"止盈价",
    设置止盈止损:"设置止盈止损",
    请输入关键词:"请输入关键词",
    搜索结果:"搜索结果",
    添加收款方式:"添加收款方式",
    高级认证:"高级认证",
    历史委托:"历史委托",
    选择区域码: "选择区域码",
    请上传身份证图片: "请上传身份证图片",
    请上传护照照片: "请上传护照照片",
    请输入提币地址: "请输入提币地址",
    设置语言: "设置语言",
    最低金额: "最低金额",
    购买金额: "购买金额",
    请输入要搜索的国家名称: "请输入要搜索的国家名称",
    确定执行该操作: "确定执行该操作?",
    历史搜索: "历史搜索",
    现货持仓: "现货持仓",
    永续持仓: "永续持仓",
    到期结算中: "到期结算中",
    火花图: "火花图",
    计价单位: "计价单位",
    您拒绝了链接: "您拒绝了链接",
    连接钱包成功: "连接钱包成功",
    已断开钱包: "已断开钱包",
    钱包切换成功: "钱包切换成功",
    请先安装钱包插件: "请先安装钱包插件",
    连接钱包: "连接钱包",
    交易: "交易",
    确认报价: "确认报价",
    您将获得: "您将获得",
    兑换自: "兑换自",
    汇率: "汇率",
    返回: "返回",
    兑换: "兑换",

    消息: "消息",
    身份证反面照片: "身份证反面照片",
    身份证正面照片: "身份证正面照片",
    手持身份证照片: "手持身份证照片",
    划转: "划转",
    请输入划转数量: "请输入划转数量(USD)",
    邀请链接: "邀请链接",
    资料总览: "资料总览",
    推广规则: "推广规则",
    总邀请人数: "总邀请人数",
    总佣金: "总佣金",
    规则1: "1.该地址仅接受{type}，请勿往该地址转入非{type}资产，否则资产将不可找回",
    规则2: "2.您充值上述地址后，需要等待网络节点确认，一旦网络节点确认后，资产会自动到账，我们将以网站公告形式通知您到账情况。",
    规则3: "3.您的充值地址不会经常改变，可以重复充值；如有更改，我们会以网站公告通知您",

    安全中心: "安全中心",
    绑定手机号: "绑定手机号",
    认证中心: "认证中心",
    身份认证: "身份认证",
    认证要求: "认证要求",
    政府发行的证件: "政府发行的证件",
    功能与限制: "功能与限制",
    无限额: "无限额",
    预计审核时间: "预计审核时间：60分钟",
    开始认证: "开始认证",
    充币规则: "充币规则",
    套期保值: "套期保值，风险对冲",
    登陆后继续: "登陆后继续",
    登录后进行交易: "登录后进行交易",
    请选择充值方式: "请选择充值方式",
    请选择取款方式: "请选择取款方式",
    客服充值:'客服充值',
    数字货币:'数字货币',
    银行取款:'银行取款',
    请输入金额: "请输入金额",
    银行名称: "银行名称",
    银行卡号: "银行卡号",
    请输入: "请输入",
    请选择: "请选择",
    类型: "类型",
    可用金额: "可用金额",
    提款: "提款",

    
    

    
}


// WEBPACK FOOTER //
// ./src/lang/zh.js